import { SECTOR } from '@constants/actions';
import { Map } from 'immutable';

const initialState = Map({
  list: [],
});

const Sector = (state = initialState, action) => {
  switch (action.type) {
    case SECTOR.LIST: 
      return state.set('list', action.payload.sectors);
    default:
      return state;
  }

};

export default Sector;